module.exports = __webpack_public_path__ + "static/media/timer.79da6a3b.svg";